module.exports = __webpack_public_path__ + "img/u1156.835bc9e9.png";